<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="680_auto"
      :visible.sync="modalVisible"
      :loading="loading"
  >
    <template #header>店铺授权</template>

    <template #content>
      <div style="padding-left: 32px;">
        <gj-steps :active="stepActive" :steps="steps"></gj-steps>
      </div>

      <br>
      <gj-carousel ref="carousel" :list="['store','ad','mail']" :indicatorPosition="'none'" height="500px">

        <!--        店铺授权-->
        <template #store>
          <storeAuthorization
              ref="storeAuthorization"
              :form="form"
              :unionAccountOption="unionAccountOption"
              @passChange="storePassChange"
              @storePassed="storePassed"
          ></storeAuthorization>
        </template>

        <!--        广告授权-->
        <template #ad>
          <adAuthorization
              ref="adAuthorization"
              :marketItem="marketItem"
              :form="form"
              :adsSupplyCountryCode="adsSupplyCountryCode"
              @passChange="adPassChange"
              @adPassed="adPassed"
          ></adAuthorization>
        </template>

        <!--        售后邮箱-->
        <template #mail>
          <mailAuthorization
              ref="mailAuthorization"
              :form="mailForm"
              :marketItem="marketItem"
          ></mailAuthorization>
        </template>

      </gj-carousel>
    </template>

    <template #footer>
      <gj-button class="handle-button" @click="prevHandle" :loading="loading" v-if="stepActive>0">上一步</gj-button>
      <gj-button class="handle-button" @click="nextHandle" :loading="loading" v-if="stepActive<2">下一步</gj-button>
      <gj-button class="handle-button" @click="confirm" type="primary" :loading="loading" v-if="stepActive===2">确定</gj-button>
      <gj-button class="handle-button" @click="skip" :loading="loading" v-if="stepActive>0">跳过</gj-button>
    </template>

  </gj-modal>
</template>

<script>
import {modalMixIn, userGuideMixin} from "@/minxins";
import {MarketEnum} from "@/views/modules/system/market/enum";
import storeAuthorization from "@/views/modules/system/market/components/store-authorization";
import adAuthorization from "@/views/modules/system/market/components/ad-authorization";
import mailAuthorization from "@/views/modules/system/market/components/mail-authorization";


export default {
  mixins: [modalMixIn, userGuideMixin],
  components: {
    storeAuthorization,
    adAuthorization,
    mailAuthorization
  },
  name: "add-step-modal",
  props:{
    adsSupplyCountryCode:{
      type:Array,
      default: function (){
        return []
      }
    }
  },
  created() {
    this.mailForm.marketIds.push(this.marketItem.marketId);
  },
  data() {
    return {
      //店铺授权是否验证
      storePass: 'none',
      adPass: 'none',
      steps: [
        {title: '店铺授权'},
        {title: '广告授权'},
        {title: '售后邮箱'}
      ],

      //提交loading状态
      loading: false,
      //步骤条步骤
      stepActive: 0,

      //店铺、广告表单
      form: {
        marketName: '',
        areaId: 'na',
        countryCodes: [],
        unionAccount: true,
        marketIds: []
      },
      countryOption: [],
      unionAccountOption: [
        {id: true, text: '是'},
        {id: false, text: '否'},
      ],

      //邮件表单
      mailForm: {
        name: '',
        type: 1,
        account: '',
        authCode: '',
        marketIds: [],
        imapServer: '',
        imapPort: '993',
        imapSsl: true,
        selectAccount: '',
      },

      marketItem: {
        region: '',
        countryCode: '',
        marketId: '',
        marketName: '',
        items: [
          {countryCode: ''}
        ]
      },

      marketId: '',
      region: ''
    }
  },
  methods: {
    storePassChange(storePass) {
      this.storePass = storePass;
    },
    adPassChange(adPass) {
      this.adPass = adPass;
    },
    storePassed(areaId) {
      this.region = areaId;
    },
    adPassed() {

    },
    prevHandle() {
      //step-1，走马灯左滑
      this.stepActive--
      this.$refs.carousel.$refs.gjCarousel.prev();
    },
    next() {
      //step+1，走马灯右滑
      this.stepActive++
      this.$refs.carousel.$refs.gjCarousel.next()
    },
    nextHandle() {
      //若在店铺授权页
      if (this.stepActive === 0) {
        if (this.storePass !== 'success') {
          this.$gjMessage.warning('店铺授权成功后才可进入下一步骤')
          return
        }
        //若按钮没有禁用
        if (!this.$refs.storeAuthorization.disabled) {
          //店铺授权
          this.loading = true;
          //刷新列表数据
          this.$refs.storeAuthorization.saveMarket((res) => {
                this.$emit('authed');
                this.loading = false;
                this.marketItem = res;
                res.items.forEach(r => {
                  if (this.adsSupplyCountryCode.indexOf(r.countryCode) > -1) {
                    this.form.marketIds.push(r.id)
                  }
                })
                this.mailForm.marketIds = res.items.map(r => {
                  return r.id
                })
                // 用户引导模式的下一步
                if(this.userGuideState) {
                  this.$emit('userGuide')
                }
                this.next()
              },
              () => {
                this.loading = false;
              }
          )
        } else {
          // 用户引导模式的下一步
          if(this.userGuideState) {
            this.$emit('userGuide')
          }
          this.next()
        }
      }
      //若在广告授权页
      else if (this.stepActive === 1) {
        if (this.adPass !== 'success') {
          this.$gjMessage.warning('广告授权成功后才可进入下一步骤')
          return
        }
        this.$refs.mailAuthorization.getSameEmails()
        this.$refs.adAuthorization.saveAD(() => {
          //刷新列表数据
          this.$emit('authed');
          // 用户引导模式的下一步
          if(this.userGuideState) {
            this.$emit('userGuide')
          }
          this.next()
        })
      }
    },
    confirm(){
      this.$refs.mailAuthorization.confirm(()=>{
        this.$emit('authed');
        this.$gjDestroy();
      });
    },
    after(){
      this.$emit('after');
    },
    skip() {
      if (this.stepActive === 1) {
        this.$refs.mailAuthorization.getSameEmails()
        this.next()
      } else {
        this.$gjDestroy();
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-step__title {
  position: relative;
  left: -14px;
  font-weight: normal;
}

/deep/ .el-step__icon {
  border-width: 1px;
}

/deep/ .el-step__icon-inner {
  font-weight: normal;
}

/deep/ .is-process {
  color: #1F6EEF;
  border-color: #1F6EEF;

  .el-step__icon {
    color: #FFFFFF;
    background-color: #1F6EEF;
  }
}

/deep/ .is-finish {
  color: #1F6EEF;
  border-color: #1F6EEF;

  .el-step__icon {
    color: #FFFFFF;
    background-color: #1F6EEF;
  }

  .el-step__line-inner {
    border-width: 1px !important;
    width: 100% !important;
  }
}

/deep/ .el-alert__icon.el-icon-info {
  color: #1F6EEF;
}

/deep/ .el-alert {
  align-items: flex-start;
}

/deep/ .el-dialog__body {

}

</style>